"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var labels = exports.labels = {
    MedSalePrice: "Median Home Price",
    SoldCount: "Number of Sales",
    SoldAvgDOM: "Days on Market",
    AvgSalePricePerSqft: "Price per Square Foot",
    SaleVolume: "Sales Volume",
    AvgSaleOverListPrice: "% of List Price Received",
    ActiveCount: "ActiveCount",
    ContingentCount: "ContingentCount",
    PendingCount: "PendingCount",
    ActiveAvgDOM: "ActiveAvgDOM",
    ActiveMedDOM: "ActiveMedDOM",
    InventoryCount: "InventoryCount",
    InventoryAvgDOM: "InventoryAvgDOM",
    InventoryAvgListPrice: "InventoryAvgListPrice",
    NewListingsCount: "NewListingsCount",
    NewListingsAvgListPrice: "NewListingsAvgListPrice",
    UnderContractCount: "UnderContractCount",
    UnderContractAvgDOM: "UnderContractAvgDOM",
    UnderContractAvgListPrice: "UnderContractAvgListPrice",
    ActiveAvgListPrice: "ActiveAvgListPrice",
    ActiveAvgListPricePerSqft: "ActiveAvgListPricePerSqft",
    ActiveAvgOriginalPrice: "ActiveAvgOriginalPrice",
    ActiveMedListPrice: "ActiveMedListPrice",
    ActiveMedListPricePerSqft: "ActiveMedListPricePerSqft",

    SoldMedDOM: "SoldMedDOM",
    SoldAvgListPrice: "SoldAvgListPrice",
    SoldMedListPrice: "SoldMedListPrice",
    AvgSalePrice: "AvgSalePrice",
    AvgSaleOverOriginalPrice: "AvgSaleOverOriginalPrice",
    MedSalePricePerSqft: "MedSalePricePerSqft"

};

var legendlabels = exports.legendlabels = {
    MedSalePrice: "Med",
    SoldCount: "Sales",
    SoldAvgDOM: "DOM",
    AvgSalePricePerSqft: "$/SF",
    SaleVolume: "Sales Volume",
    AvgSaleOverListPrice: "SP/LP",
    ActiveCount: "ActiveCount",
    ContingentCount: "ContingentCount",
    PendingCount: "PendingCount",
    ActiveAvgDOM: "ActiveAvgDOM",
    ActiveMedDOM: "ActiveMedDOM",
    InventoryCount: "InventoryCount",
    InventoryAvgDOM: "InventoryAvgDOM",
    InventoryAvgListPrice: "InventoryAvgListPrice",
    NewListingsCount: "NewListingsCount",
    NewListingsAvgListPrice: "NewListingsAvgListPrice",
    UnderContractCount: "UnderContractCount",
    UnderContractAvgDOM: "UnderContractAvgDOM",
    UnderContractAvgListPrice: "UnderContractAvgListPrice",
    ActiveAvgListPrice: "ActiveAvgListPrice",
    ActiveAvgListPricePerSqft: "ActiveAvgListPricePerSqft",
    ActiveAvgOriginalPrice: "ActiveAvgOriginalPrice",
    ActiveMedListPrice: "ActiveMedListPrice",
    ActiveMedListPricePerSqft: "ActiveMedListPricePerSqft",

    SoldMedDOM: "SoldMedDOM",
    SoldAvgListPrice: "SoldAvgListPrice",
    SoldMedListPrice: "SoldMedListPrice",
    AvgSalePrice: "AvgSalePrice",
    AvgSaleOverOriginalPrice: "AvgSaleOverOriginalPrice",
    MedSalePricePerSqft: "MedSalePricePerSqft"
};


//////////////////
// WEBPACK FOOTER
// ./~/react-markettrendswidget/lib/labels.js
// module id = 283
// module chunks = 0